import React, { useState, useEffect, useCallback } from 'react';
import { useSnackbar } from 'notistack';
import { Grid } from '@material-ui/core';
import ButtonComponent from '@components/Shared/Buttons/Button';
import { Visibility } from '@material-ui/icons';
import { IPerfil } from '@interfaces/UserComplete';
import useDebounce from '@hooks/useDebounce';
import { MaskCPFeCNPJ } from '@utils/Masks';
import { Form, Select as SelectAntd,  Input, Spin, Radio } from 'antd';
import { LinkRoute } from '@src/Pages/Private/Cliente/shared/NovoCadastro/styles';


import Services, {
  IPerfils,
  IGetAllProgramaTv,
  IRequestCreateProgramaTV,
} from './services';

const optionsFilter = ['ID', 'CPF/CNPJ'];

const SolicitacaoIntencao: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [formRef] = Form.useForm();
  const [loadingCreateProgramaTV, setLoadingCreateProgramaTV] = useState(false);
  const [viewConfirmation, setViewConfirmation] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState(
    optionsFilter[optionsFilter.length - 1],
  );
  const [valueInput, setValueInput] = useState('');
  const [enableSearchForm, setEnableSearchForm] = useState(false);
  const [respostaErroBuscaPerfil, setRespostaErroBuscaPerfil] = useState('');
  const [loadingTipoPerfil, setLoadingTipoPerfil] = useState(false);
  const [statePessoa, setStatePessoa] = useState({
    Nome: '',
    id: '',
  });

  const [perfis, setPerfis] = useState<IPerfil[]>([]);
  const [loadingPerfil, setLoadingPerfil] = useState(false);
  const [checkCidade, setCheckCidade] =
  useState<any>('');
  const [checkUf, setCheckUf] = useState<any>();

  const [perfilID, setIdPerfil] = useState<number>(0);
  const [etapa, setEtapa] = useState<number>(0);

  const [tiposProgramasTv, setTiposProgramasTv] = useState<IGetAllProgramaTv[]>([]);
  const [idExists, setIdExists] = useState<any>();


  const handleSelectFilter = (value: string) => {
    setSelectedFilter(value);
    //setSelectedFilterIndicador(value);
    formRef.setFieldsValue({
      tipo_perfil: undefined,
    });
    setPerfis([]);
  };

  const getPessoaByDocumento = async (documento: string) => {
    setRespostaErroBuscaPerfil('');
    setLoadingTipoPerfil(true);
    const service = new Services();

    const { error, response } = await service.getPessoaByDocumento(documento);

    if (!error && response) {
      setPerfis(response.pessoa.perfis);
      if (response.pessoa.perfis.length <= 0) {
        setRespostaErroBuscaPerfil(
          'Não existe perfil cadastrado para este CPF/CNPJ',
        );
      }
      if (!error && response) {
        setStatePessoa({
          Nome: response.pessoa.nome,
          id: response.pessoa.id,
        });
        setPerfis(response.pessoa.perfis);
        setViewConfirmation(true);
        setIdExists(response.pessoa.id)
      }
    } else {
      setViewConfirmation(false);
      setRespostaErroBuscaPerfil(
        'Não existe uma pessoa cadastrada para este CPF/CNPJ',
      );
    }
    setLoadingTipoPerfil(false);
    clearDataPerfil();
  };

  const getPessoaByID = async (id: number) => {
    setRespostaErroBuscaPerfil('');
    setLoadingTipoPerfil(true);
    const service = new Services();

    const { error, response } = await service.getPessoaByID(id);

    if (!error && response) {
      setPerfis(response.pessoa.perfis);
      if (response.pessoa.perfis.length <= 0) {
        setRespostaErroBuscaPerfil('Não existe perfil cadastrado para este ID');
      }
      if (!error && response) {
        setStatePessoa({
          Nome: response.pessoa.nome,
          id: response.pessoa.id,
        });
        setPerfis(response.pessoa.perfis);
        setViewConfirmation(true);
        setIdExists(response.pessoa.id)

      }
    } else {
      setRespostaErroBuscaPerfil(
        'Não existe uma pessoa cadastrada para este ID',
      );
      setViewConfirmation(false);
    }
    setLoadingTipoPerfil(false);

    clearDataPerfil();
  };

  const debounceOnChange = (value: string) => {
    formRef.setFieldsValue({
      tipo_perfil: undefined,
    });
    setPerfis([]);
    if (selectedFilter === 'CPF/CNPJ') {
      debounceGetPessoaByDocumento(value);
    } else if (selectedFilter === 'ID') {
      debounceGetPessoaByID(parseInt(value));
    }
  };

  const debounceGetPessoaByDocumento = useDebounce(getPessoaByDocumento, 1000);
  const debounceGetPessoaByID = useDebounce(getPessoaByID, 1000);


  const loadPerfil = useCallback(async perfilID => {
    setLoadingPerfil(true);
    const services = new Services();
    const { error, response } = await services.GetPerfilByID({ id: perfilID });

    if (!error && response) {

      const perfils: IPerfils = {contato_offline: response.contato_offline,};
      setCheckCidade(perfils.contato_offline.cidade_id)
      setCheckUf(perfils.contato_offline.estado_id)
      //checkTipoOperacao(perfilTriagem.debito_automatico.operacao)

      formRef.setFieldsValue({
        estado_descricao: response.contato_offline.estado_descricao,
        cidade_id: response.contato_offline.cidade_descricao,
        contato_offline: response.contato_offline,
      });
      setLoadingPerfil(false);
    } else {
      console.log('error', error);
    }
  }, []);


  const loadProgramasTv = async () => {
    const services = new Services();
    const { error, response } = await services.GetAllProgramaTv();

    if (!error && response) {
      setTiposProgramasTv(response);

    }
  };

  async function onSubmitCadastrados(values: any) {
    setLoadingCreateProgramaTV(true);

    console.log(values);

    const createIntencao: IRequestCreateProgramaTV = {
      //horario: values.horario,
     // dia_semana: values.dia_semana,
     descricao: values.descricao,
     //nome_completo: values.nome,
     //data_intencao_missa: values.data_intencao_missa,
     id_perfil: perfilID,
     id_programa: values.programa_id,
     //id_cidade: checkCidade,
     //id_estado: checkUf,
     //id_tipo_solicitacao: tipoSolicitacaoIntencaoMissa,
     //id_tipo_intencao_missa: values.id_tipo_intencao_missa,
    };

    const service = new Services();
    const { error, response } = await service.CreateProgramaTV(
      createIntencao,
    );

    //setLoadingCreate(false);

    if (!error) {
      enqueueSnackbar(`Cadastro finalizado com sucesso!`, {
        variant: 'success',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      setLoadingCreateProgramaTV(false);
    } else {
      enqueueSnackbar(`Ocorreu um erro`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      setLoadingCreateProgramaTV(false);
    }
  }


  const clearDataPerfil = () => {
    formRef.setFieldsValue({
      estado_descricao: '',
      cidade_id: '',
      id_perfil: '',
    });
  };

  const clearDataHorario = () => {
    formRef.setFieldsValue({
      id_horario_dias_semana: '',
    });
  };


  const clearData = () => {
    formRef.setFieldsValue({
      estado_descricao: '',
      estado_id: '',
      cidade_id: '',
      id_perfil: '',
      nome: '',
      id_tipo_intencao_missa: '',
      data_intencao_missa: '',
      id_horario_dias_semana: '',
      descricao: '',
      cpf: ''
    });
  };

  useEffect(() => {
   loadProgramasTv();
    window.document.title = 'CRM - Programa TV';
  }, []);

  return (
    <Grid container>
      <Grid
        container
        item
        sm={12}
        xs={12}
        style={{ marginTop: 20 }}
      >

        <Grid container item lg={5} sm={5} xs={12} style={{ padding: 0 }}>


        </Grid>

        {/* FORMULARIO  */}

        {/* PESSOAS CADASTRADOS */}
          <Grid item sm={12} xs={12}>
            <Spin
              size="large"
              spinning={loadingCreateProgramaTV}
              tip="Enviando dados..."
            >
              <Form
                form={formRef}
                size="middle"
                layout="vertical"
                scrollToFirstError={true}
                onFinish={onSubmitCadastrados}
                labelAlign="left"
                labelCol={{
                  span: 24,
                }}
                wrapperCol={{
                  span: 24,
                }}
                requiredMark={false}
                initialValues={{
                  estado_descricao: '',
                  cidade_id: '',
                  id_perfil: '',
                  id_tipo_intencao_missa: '',
                  data_intencao_missa: '',
                  id_horario_dias_semana: '',
                  descricao: '',
                  cpf: ''
                }}
                >

                <Grid container item lg={12} sm={12} xs={12} style={{ paddingTop: 10 }}>
                  <Grid container item lg={5} sm={5} xs={12} style={{ padding: 0 }}>
                    <Spin spinning={loadingTipoPerfil} tip="Buscando perfil">
                        <Grid container item lg={12} sm={12} xs={12}>

                          <Grid
                            item
                            md={4}
                            lg={4}
                            xs={12}
                            style={{ paddingLeft: 10, paddingRight: 10 }}
                          >
                            Filtrar pessoa
                              <SelectAntd
                                style={{ width: '100%' }}
                                onChange={(e: string) => {
                                  setValueInput('');
                                  handleSelectFilter(e);
                                  setViewConfirmation(false);
                                  formRef.setFieldsValue({
                                    cpf: undefined,
                                  });
                                  setEnableSearchForm(true);
                                }}
                              >
                                {optionsFilter.map((option, index) => (
                                  <SelectAntd.Option key={option} value={option}>
                                    {option}
                                  </SelectAntd.Option>
                                ))}
                              </SelectAntd>
                          </Grid>

                          <Grid
                            item
                            md={8}
                            lg={8}
                            xs={12}
                            style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 20 }}
                          >
                            <Form.Item
                              name="cpf"
                              rules={[
                                {
                                  required: true,
                                  message: 'Digite um documento',
                                },
                              ]}
                            >
                              <Input
                                disabled={!enableSearchForm}
                                minLength={14}
                                maxLength={18}
                                name={selectedFilter}
                                value={valueInput}
                                type={
                                  selectedFilter === 'ID' || selectedFilter === 'ID AFIPE'
                                  ? 'number'
                                  : 'text'
                                }
                                onChange={(e: any) => {
                                  setViewConfirmation(false);
                                  if (selectedFilter === 'CPF/CNPJ') {
                                    formRef.setFieldsValue({
                                      cpf: MaskCPFeCNPJ(e.target.value).valueModify,
                                    });
                                  }
                                  if (
                                    selectedFilter === 'CPF/CNPJ' &&
                                    e.target.value.length >= 14
                                  ) {
                                    debounceOnChange(e.target.value);
                                  } else if (selectedFilter !== 'CPF/CNPJ') {
                                    debounceOnChange(e.target.value);
                                  }
                                }}
                              />
                            </Form.Item>
                          </Grid>
                        </Grid>

                        <div style={{color: "#FF0000"} }>
                          {respostaErroBuscaPerfil}
                        </div>

                        <Grid
                          item
                          lg={12}
                          xs={12}
                          style={{ paddingRight: 10, paddingLeft: 10 }}
                        >
                          <Form.Item
                            label='Nome'
                          >
                            <Input
                              disabled
                              value= {statePessoa.Nome}
                            />
                          </Form.Item>
                        </Grid>

                        <Grid item lg={12} xs={12} style={{ paddingRight: 10, paddingLeft: 10 }}>
                          <Form.Item
                            name="id_perfil"
                            label="Tipo de perfil"
                            rules={[
                              {
                                required: true,
                                message: 'Selecione um perfil',
                              },
                            ]}
                            style={{ paddingTop: 0 }}
                          >
                            <SelectAntd
                              disabled={perfis.length <= 0}
                              placeholder="Tipo de perfil"
                              onChange={(id: number) => {
                                setIdPerfil(id);
                                //loadPerfil(id)
                              }}
                            >
                              {perfis.map((item, index) => (
                                <SelectAntd.Option key={index} value={item.perfil_id}>
                                  {item.tipo_perfil_descricao}
                                </SelectAntd.Option>
                              ))}
                            </SelectAntd>
                          </Form.Item>
                        </Grid>

                        {viewConfirmation && (
                          <Grid item xs={12} lg={12} md={12}>
                            <LinkRoute
                              onClick={() => window.open(`/cadastro/${idExists}/`)}
                            >
                              Visualizar cadastro
                              <Visibility style={{ marginLeft: 10 }} />
                            </LinkRoute>
                          </Grid>
                        )}

                        <Grid
                          container
                          justify="center"
                          alignItems="center"
                          item
                          md={12}
                          xs={12}
                        >
                          <Grid item md={5} xs={12} style={{ paddingTop: 10 }}>
                            <ButtonComponent
                              color="secondary"
                              fullWidth

                              //disabled={etapa !== 1}
                              //loading={loadingCreateSolicitacao}
                              onClick={() => {
                                setEtapa(2);
                              }}
                            >
                              Seguinte
                            </ButtonComponent>
                          </Grid>
                        </Grid>
                      </Spin>

                  </Grid>

                  <Grid container item lg={1} sm={1} xs={12} style={{ padding: 0 }}></Grid>

                  <Grid container item lg={5} sm={5} xs={12} style={{ padding: 0 }}>
                    <Grid
                      item
                      md={12}
                      lg={12}
                      xs={12}
                      style={{ paddingLeft: 10, paddingRight: 10 }}
                    >
                      <Form.Item
                        label=' Tipo solicitação'                    >
                        <Input
                        value={'Programa TV'}
                        disabled
                        />
                      </Form.Item>
                    </Grid>

                    <Grid
                      item
                      lg={12}
                      xs={12}
                      style={{ paddingRight: 10, paddingLeft: 10 }}
                    >
                      <Form.Item
                        label='Tipo programa'
                        name="programa_id"
                        rules={[
                          { required: true, message: 'Campo obrigatorio' },
                        ]}
                      >
                        <SelectAntd
                          style={{ width: '100%' }}
                          disabled={etapa !== 2}
                        >
                          {tiposProgramasTv.map((option, index) => (
                            <SelectAntd.Option key={option.id} value={option.id}>
                              {option.nome}
                            </SelectAntd.Option>
                          ))}
                        </SelectAntd>
                      </Form.Item>
                    </Grid>


                    <Grid item lg={12} xs={12} style={{ paddingRight: 10, paddingLeft: 10 }}>
                      <Form.Item
                        label='Descrição'
                        name="descricao"
                      >
                        <Input style={{height: 50}}  disabled={etapa !== 2} />
                      </Form.Item>
                    </Grid>

                    <Grid
                      container
                      justify="center"
                      alignItems="center"
                      item
                      md={12}
                      xs={12}
                    >
                      <Grid item md={5} xs={12} style={{ paddingTop: 10 }}>
                        <ButtonComponent
                          color="default"
                          fullWidth
                          onClick={clearData}
                        >
                          Cancelar
                        </ButtonComponent>
                      </Grid>

                      <Grid item md={1} xs={12} style={{ paddingTop: 10 }}></Grid>

                      <Grid item md={5} xs={12} style={{ paddingTop: 10 }}>
                        <ButtonComponent
                          color="primary"
                          fullWidth
                          type="submit"
                        >
                          Solicitar
                        </ButtonComponent>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Form>
            </Spin>
          </Grid>



      </Grid>
    </Grid>
  );
};

export default SolicitacaoIntencao;
